import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
import IconButton from '../IconButton';
var ToggleButton = styled(IconButton).attrs(function (_a) {
    var color = _a.color, checked = _a.checked, disabled = _a.disabled;
    return ({
        type: 'switch',
        color: !checked && !disabled ? undefined : color,
    });
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  > .sinoui-icon,\n  > .sinoui-svg-icon {\n    font-size: 20px;\n  }\n  width: 20px;\n  height: 20px;\n  > .sinoui-icon-button__ripple-layout-dense {\n    left: -6px;\n    top: -6px;\n  }\n  > .sinoui-icon-button__ripple-layout {\n    left: -14px;\n    top: -14px;\n  }\n"], ["\n  ",
    ";\n  > .sinoui-icon,\n  > .sinoui-svg-icon {\n    font-size: 20px;\n  }\n  width: 20px;\n  height: 20px;\n  > .sinoui-icon-button__ripple-layout-dense {\n    left: -6px;\n    top: -6px;\n  }\n  > .sinoui-icon-button__ripple-layout {\n    left: -14px;\n    top: -14px;\n  }\n"])), function (props) {
    return !props.checked &&
        !props.disabled &&
        "color: " + props.theme.palette.text.secondary + ";";
});
export default ToggleButton;
var templateObject_1;
//# sourceMappingURL=ToggleButton.js.map